import { css } from 'styled-components';
import { ReturnToCartProps } from './models';

export const ReturnToCart = css<ReturnToCartProps>(
  ({ theme }) => `
     .title-text {
      font-weight: 600;
      font-size: 25px;
      line-height: 30px;
      display: flex;
      align-items: center;
      text-align: center;    
      color: ${theme.colors.primaryBackground};
      margin-bottom: 25px;
    }
     .description-text {
      font-weight: 500;
      font-size: 17px;
      line-height: 27px;
      display: flex;
      align-items: center;
      text-align: center;    
      color: ${theme.colors.primaryBackground};
    }
`
);
